import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getSingleDeHubProduct, GetAllDeCategory } from '../../../api/apiService';
import { Divider } from '@mui/material';
import { useHistory } from 'react-router';

const SingleDeHubProductDetails = () => {
  const { search } = useLocation(), history = useHistory();
  const hubId = new URLSearchParams(search).get('hubId');
  const productId = new URLSearchParams(search).get('productId');

  const [product, setProduct] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [productRes, categoryRes] = await Promise.all([
          getSingleDeHubProduct(hubId, productId),
          GetAllDeCategory()
        ]);
        const data = productRes.data.data;
        const category = categoryRes.data.data.find(c => c._id === data.categoryId?._id)?.name || '';
        setProduct({ ...data, category });
      } catch (err) {
        console.error("Failed to fetch product:", err);
      }
    })();
  }, [hubId, productId]);


  const Display = ({ label, value, col = 3 }) => (
    <div className={`col-sm-${col} col-12 mb-3`}>
      <strong>{label}:</strong> <span className="text-muted">{value || 'N/A'}</span>
    </div>
  );

  if (!product) return <div>Loading...</div>;

  return (
    <div className=" mt-4">
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="mb-3">Product Details</h4>
        <button type="button" className="btn btn-verify" onClick={()=>history.push(`/daily-essentials/hubs/single-hub/product-from?hubId=${hubId}&productId=${productId}`)}> Update</button>
      </div>
      <Divider />
      <div className="row mt-3">
        <Display label="Product Name" value={product.product_name} />
        <Display label="Local Name" value={product.local_name} />
        <Display label="Category" value={product.category} />
        <Display label="Subcategories" value={(product.populatedSubCategories?.map((subCat) => subCat.name) || []).join(', ')} />
        <Display label="Quantity" value={product.qty} />
        <Display label="Unit" value={product.unit} />
        <Display label="MRP" value={`₹${product.mrp}`} />
        <Display label="Sell Price" value={`₹${product.sellPrice}`} />
        <Display label="Buy Price" value={`₹${product.buyPrice}`} />
        <Display label="Tax" value={`${product.tax}%`} />
        <Display label="Min Order Qty" value={product.minOrderQty} />
        <Display label="Max Order Qty" value={product.maxOrderQty} />
        <Display label="Packaging Charge" value={`₹${product.packagingCharge}`} />
        <Display label="Manufacturing Date" value={product.mfgDate?.slice(0, 10)} />
        <Display label="Expiry Date" value={product.expiryDate?.slice(0, 10)} />
        <Display label="Nutrition Info" value={product.nutretionalInfo} col={12} />
        <Display label="Description" value={product.description} col={12} />
        <div className="col-12 mt-3">
          <h6>Product Images</h6>
          <div className="d-flex flex-wrap gap-3">
            {product.images?.length > 0 ? (
              product.images.map((img, i) => (
                <img key={i} src={img} alt={`Product ${i}`}
                  style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px' }}
                />
              ))
            ) : (
              <p>No images available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleDeHubProductDetails;
